




















import {Component, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/DialogMixins';

@Component({
  inheritAttrs: false,
})
export default class ReloadDialog extends Mixins(DialogMixin) {
  hardwareMac = '';

  onOk() {
    this.$emit('reloadHardware', this.hardwareMac);
    return this.close();
  }

  open(hardwareMac: string) {
    this.dialog = true;
    this.hardwareMac = hardwareMac;
  }
}
